import { SearchIcon } from '@/components/icons'
import { HTMLProps, forwardRef } from 'react'

export type AccountSearchInputProps = HTMLProps<HTMLInputElement> & {
  iconClassName?: string
  containerClassName?: string
  label?: string
  labelClassName?: string
  error?: string
}

export const AccountSearchInput = forwardRef<HTMLInputElement, AccountSearchInputProps>(
  ({ iconClassName, containerClassName, className, label, labelClassName, error, ...props }, ref) => {
    return (
      <div>
        {label && <p className={`${labelClassName ? labelClassName : ''}`}>{label}</p>}
        <div
          className={`flex flex-row w-full items-center rounded-[70px] justify-center bg-white overflow-hidden px-4 ${
            containerClassName ? containerClassName : ''
          }`}
        >
          <SearchIcon width={30} height={30} className={`text-navy-900 ${iconClassName ? iconClassName : ''}`} />
          <input
            type="text"
            className={`w-full py-4 pl-4 outline-none ${className ? className : ''}`}
            ref={ref}
            {...props}
          />
        </div>
        {error && <div className="text-boldOrange mt-1 font-medium">{error}</div>}
      </div>
    )
  }
)

export default AccountSearchInput
